import axios from '@/libs/api.request'

/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const getList = (params) => {
  return axios.request({
    url: 'LhcManage/LhcUrlTemplate/index',
    method: 'get',
    params: params
  })
}


/**
 * 删除数据
 */
export const del = (id) => {
  return axios.request({
    url: 'LhcManage/LhcUrlTemplate/del',
    method: 'get',
    params: {
      id: id
    }
  })
}


/**
 * 锁定/解锁
 */
export const lock = (id) => {
  return axios.request({
    url: 'LhcManage/LhcUrlTemplate/lock',
    method: 'get',
    params: {
      id: id
    }
  })
}

/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const getParams = (id,isRecover=0) => {
  return axios.request({
    url: 'LhcManage/LhcUrlTemplate/getParams',
    method: 'get',
    params: {
      id: id,
      isRecover:isRecover
    }
  })
}


/**
 * 改变状态按钮
 * @param status
 * @param id
 * @returns {wx.RequestTask | never}
 */
export const changeStatus = (status, id) => {
  return axios.request({
    url: 'LhcManage/LhcUrlTemplate/changeStatus',
    method: 'get',
    params: {
      status: status,
      id: id
    }
  })
}

/**
 * 新增
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const add = (data) => {
  return axios.request({
    url: 'LhcManage/LhcUrlTemplate/add',
    method: 'post',
    data
  })
}

/**
 * 编辑
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const edit = (data) => {
  return axios.request({
    url: 'LhcManage/LhcUrlTemplate/edit',
    method: 'post',
    data
  })
}
